import { render, staticRenderFns } from "./SectionVideo.vue?vue&type=template&id=153eeecc&scoped=true"
import script from "./SectionVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionVideo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SectionVideo.vue?vue&type=style&index=0&id=153eeecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153eeecc",
  null
  
)

export default component.exports